import { Table as LibTable, type Column, type TableProps } from 'grabbitbot-legacy-ui'

/**
 * The one shared table of this app (fleet frontend-standards §1): the
 * grabbitbot-legacy-ui sortable, hover-highlighted Table, with this app's
 * alignment default — numeric columns right (tabular figures), everything
 * else left. The library defaults every column to right and leaves the
 * choice to the caller; making it here once keeps ~40 column lists short.
 */
export function Table<T>(props: TableProps<T>) {
  const columns: Column<T>[] = props.columns.map((c) => (c.align ? c : { ...c, align: c.numeric ? 'right' : 'left' }))
  return <LibTable {...props} columns={columns} className={['gbx-table', 'fs-table', props.className].filter(Boolean).join(' ')} />
}
